define('plugin/package/view/PackageEmptyView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Package empty view
     *
     * @class PackageEmptyView
     */
    return LayoutView.extend({

        template: '#package_empty_view',

        serializeData: function () {
            return {
                message: 'package_empty_view_list_message'
            };
        }
    });

});
